<template>
  <div class="main">
    <el-row class="header">
      <div class="logo" @click="go(0)">
        <img src="../assets/image/logo.png" alt=""/>
        <div class="text">GOODAL REAL ESTATE</div>
      </div>
      <el-row class="row flex_around top_pos">
        <el-col :span="6" class="top_menu" @click.native.stop="open(1)" @mouseover.native.stop="open(1)">了解赞百</el-col>
        <el-col :span="6" class="top_menu" @click.native.stop="open(2)" @mouseover.native.stop="open(2)">专业服务</el-col>
        <el-col :span="6" class="top_menu" @click.native.stop="open(3)" @mouseover.native.stop="open(3)">行业动态</el-col>
        <el-col :span="6" class="top_menu" @click.native.stop="open(4)" @mouseover.native.stop="open(4)">招贤纳士</el-col>
      </el-row>
    </el-row>
    <div
      class="recover"
      :class="{ btnLeft: !menuLeftBtn, btnRight: menuLeftBtn }"
      @mouseleave.stop="handleClose"
    >
      <div class="posMargin" v-if="type === 1">
        <div class="row flex_around">
          <div @click="go(1)">
            <div class="infoTitle">公司介绍</div>
            <div class="topInfo">
              赞百房地产经纪有限公司（ZBGER）,是商办不动产领域领先的房地产专业咨询服务和投资管理机构，凭借行业领先的服务意识，我们始终致力于为合作伙伴创造机遇、打造理想空间、提供解决方案，努力塑造行业典范，创造领域完美的价值

              <div class="play">
                <img src="../assets/image/plays.png"/>
              </div>
            </div>
          </div>
          <div @click="go(2)">
            <div class="infoTitle">成功案例</div>
            <div class="topInfo">
              赞百地产是商业不动产领域的新兴代表，我们专家式的业务能力、市场前沿的动态、正确的价值观获得了合作伙伴的一致认可，在行业领域的突出表现，获得了市场认可与尊重，不仅在上海大本营成绩卓越，更在杭州、北京、武汉、长沙等一二线城市受到合作伙伴的高度信任
              <div class="play">
                <img src="../assets/image/plays.png"/>
              </div>
            </div>
          </div>
          <div @click="go(3)">
            <div class="infoTitle">联系我们</div>
            <div class="topInfo">
              赞百地产秉承的价值观是“开放透明，进化进步”，我们张开双手敞开怀抱，欢迎合作伙伴随时来联系我们，无论是关于市场、服务、产品或者其他任何需要了解，我们有极大的意愿与您探讨并分享。
              <div class="play">
                <img src="../assets/image/plays.png"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="posMargin" v-if="type === 2">
        <div class="row flex_around">
          <div @click="go(4)">
            <div class="infoTitle">客户服务</div>
            <div class="topInfo">
              客户是赞百最为宝贵的合作伙伴，让客户对我们的服务十分满意，是我们不懈的追求，我们深切的感受到，客户对我们超高的要求与期望值，我们加强平台的价值观建设，让客户利益受损，赞百绝不能接受。
              <div class="play">
                <img src="../assets/image/plays.png"/>
              </div>
            </div>
          </div>
          <div @click="go(5)">
            <div class="infoTitle">业主服务</div>
            <div class="topInfo">
              业主是赞百地产最为真诚的合作伙伴，让业主对我们的能力十分信任，是我们努力的方向，我们深知诚信、合作、交流、共赢是长期合作的基础，赞百平台最大的价值，与业主共生共赢，携手创造价值。
              <div class="play">
                <img src="../assets/image/plays.png"/>
              </div>
            </div>
          </div>
          <div @click="go(6)">
            <div class="infoTitle">附加值服务</div>
            <div class="topInfo">
              附加值服务是贯穿赞百整个服务流程的核心，是客户满意、业主认可、平台持续发展的根本，赞百不仅仅提供原有价值的服务，更通过市场、技术、供应商创造新的价值。
              <div class="play">
                <img src="../assets/image/plays.png"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="posMargin" v-if="type === 3">
        <div class="row flex_around">
          <div @click="go(7)">
            <div class="infoTitle">市场热点</div>
            <div class="topInfo">
              客户是赞百最为宝贵的合作伙伴，让客户赞百地产站在行业最前沿，对于市场热点保持高度敏感和持续研究，牢牢掌握商办不动产领域的新风向，行业专业人士与智库等合作伙伴、提供最新的市场信息，对于市场热点我们总是有全新的思考与行动。对我们的服务十分满意，是我们不懈的追求，我们深切的感受到，客户对我们超高的要求与期望值，我们加强平台的价值观建设，让客户利益受损，赞百绝不能接受。
              <div class="play">
                <img src="../assets/image/plays.png"/>
              </div>
            </div>
          </div>
          <div @click="go(8)">
            <div class="infoTitle">行业趋势分析</div>
            <div class="topInfo">
              赞百地产对商办不动产领域现状调研，以及对行业趋势进行分析，对行业运行数据进行剖析，上下游产业链进行梳理，详细分析竞争格局和前景进行趋势分析，使合作伙伴能以对行业趋势的分析，更优异的能力去参与市场竞争。
              <div class="play">
                <img src="../assets/image/plays.png"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="posMargin" v-if="type === 4">
        <div class="row flex_around">
          <div @click="go(9)">
            <div class="infoTitle">社会招聘</div>
            <div class="topInfo">
              赞百地产作为商业不动产领域的新兴力量
              十分欢迎有从事该领域经验的专业人士
              相信你高尚的品质、专业能力与价值观我们会倍加认可
              如果你是千里马，赞百这个平台任你驰骋。
              <div class="play">
                <img src="../assets/image/plays.png"/>
              </div>
            </div>
          </div>
          <div @click="go(10)">
            <div class="infoTitle">校园招聘</div>
            <div class="topInfo">
              我们高度重视人才的培养 如果你离开学校，寻找你认可的平台
              我们专注、互信、开放、透明我们会倍加珍惜
              让你在平台“天高任鸟飞、海阔任鱼跃”是大家所愿
              <div class="play">
                <img src="../assets/image/plays.png"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data () {
    return {
      imgList: [
        {url: require('../assets/image/menu1.png')},
        {url: require('../assets/image/menu2.png')},
        {url: require('../assets/image/menu3.png')}
      ],
      drawer: false,
      direction: 'ttb',
      menuLeftBtn: false,
      type: 1
    }
  },
  watch: {},
  created () {
  },
  mounted () {
  },
  methods: {
    go (val) {
      this.menuLeftBtn = false
      switch (val) {
        case 0:
          this.$router.push('/home')
          break
        case 1:
          this.$router.push('/know')
          break
        case 2:
          this.$router.push('/success')
          break
        case 3:
          this.$router.push('/contact')
          break
        case 4:
          this.$router.push('/serve')
          break
        case 5:
          this.$router.push('/owner')
          break
        case 6:
          this.$router.push('/add')
          break
        case 7:
          this.$router.push('/analysis')
          break
        case 8:
          this.$router.push('/trend')
          break
        case 9:
          this.$router.push('/society')
          break
        case 10:
          this.$router.push('/school')
          break
      }
    },
    open (type) {
      this.menuLeftBtn = true
      document.body.addEventListener('click', () => {
        this.menuLeftBtn = false
      })
      this.type = type
    },
    handleClose () {
      this.menuLeftBtn = false
    }
  }
}
</script>
<style scoped>
.row {
  display: flex;
}

.flex_around {
  justify-content: space-around;
}

.flex_around > div {
  cursor: pointer;
}

.logo {
  position: absolute;
  text-align: center;
  cursor: pointer;
  left: 8%;
}

.logo img {
  margin-top: 5px;
  padding: 5px;
  height: 45px;
  width: 40px;
}

/*手机*/
@media screen and (max-width: 600px) {
  .top_menu{
    font-size: 35px!important;
  }
}

.top_pos {
  margin: 0 auto;
  max-width: 1200px;
  height: 90px;
  line-height: 90px;
}

.top_pos > div {
  text-align: center;
  user-select: none;
}

.top_menu {
  cursor: pointer;
  font-size: 20px;
}

.top_menu:hover {
  color: #2e82ff;
}

.top_img {
  position: relative;
}

.top_img img {
  width: 100%;
  height: 540px;
  object-fit: cover;
}

.el-carousel__item h3 {
  color: #475669;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
  text-align: center;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.menu img {
  height: 400px;
  width: 100%;
}

.content {
  position: relative;
  top: -100px;
  width: 80%;
}

.flex_center {
  justify-content: center;
}

.top_note {
  position: absolute;
  top: 40px;
  font-size: 20px;
  line-height: 36px;
  left: 10%;
}

.title {
  /* width: 400px; */
  font-size: 40px;
  margin-bottom: 20px;
}

.center {
  text-align: center;
}

.note {
  width: 500px;
  text-align: left;
  line-height: 30px;
}

.note1 {
  width: 500px;
  text-align: left;
  line-height: 30px;
}

.link_width {
  width: 160px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  line-height: 26px;
}

.link_width img {
  width: 20px;
  height: 20px;
  position: relative;
  top: 3px;
  left: 6px;
}

.middle img {
  width: 100%;
  height: 700px;
  object-fit: cover;
}

.pos {
  position: relative;
  top: -80px;
}

.bank {
  width: 90%;
  margin: 0 auto;
}

.bank img {
  height: 51px;
  width: 100%;
}

.flex_between {
  justify-content: space-between;
}

.case {
  margin: 40px 0;
}

.margin {
  margin: 64px 0;
}

.subTitle {
  font-size: 40px;
  margin-top: 40px;
  margin-bottom: 20px;
}

/* .writeImg img{
  width: 100%;
  height: 500px;
} */
.note2 {
  width: 30%;
}

.titlePos {
  /* position: relative;
  left: 10%; */
  margin-left: 10%;
  margin-top: 20px;
}

.imgWidth {
  width: calc(100% / 2);
  /* height: 300px; */
}

.footer {
  position: absolute;
  width: 100%;
  background: #171717;
  height: 500px;
}

.bottom {
  margin: 0 auto;
  width: 1200px;
  color: #fff;
}

.bottom_info {
  /* width: 200px */
}

.bottom_title {
  font-size: 26px;
  margin-top: 70px;
  margin-bottom: 14px;
}

.bottom_num {
  font-size: 18px;
}

.bottom_explain {
  font-size: 36px;
  margin-bottom: 14px;
}

.marginTop {
  margin-top: 60px;
}

.bottom_text {
  font-size: 26px;
  color: #a5a5a5;
  line-height: 46px;
}

.footerImg {
  position: relative;
  top: 50px;
}

.footerImg img {
  height: 220px;
}

.footerWidth {
  width: 800px;
}

.line {
  width: 100%;
  height: 4px;
  background: #fff;
  margin-top: 40px;
}

.recover {
  position: fixed;
  z-index: 888;
  width: 100%;
  background: white;
  overflow: hidden;
  /* left: 236px;
  bottom: 10px; */
}

.btnLeft {
  top: -36px;
  height: 90px;
  transition: all .3s ease;
}

.btnRight {
  top: 90px;
  height: auto;
  transition: all .3s ease;
}

.header {
  position: fixed;
  z-index: 999;
  background: #fff;
  width: 100%;
  height: 90px;
}

.topInfo {
  position: relative;
  width: 300px;
  font-size: 16px;
  line-height: 26px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-height: 28px;
  max-height: 106px;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.infoTitle {
  font-size: 18px;
  margin-left: 26px;
  margin-bottom: 26px;
}

.posMargin {
  margin: 0 20%;
  padding: 26px 0;
}

.play {
  position: absolute;
  right: 0;
  top: 60px;
}

.play img {
  width: 20px;
  height: 20px;
}

.main {
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue